import React from 'react';

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const EcapHeader = ({header, ecapName}) => {
    if (!header) return;

    const addressFormatted = [
        header.address,
        header.number && (header.address ? " - " : "") + header.number,
        header.neighborhood && (header.address || header.number ? ", " : "") + header.neighborhood,
        header.city && (header.address || header.number || header.neighborhood ? ", " : "") + header.city,
    ].filter(Boolean).join('');

    // imagePath comes from the backend already prefixed with its own mount path; swap it for ours
    const imagePath = header?.imagePath ? API_URL + header.imagePath.replace(/^\/[^/]+/, "") : `${API_KEEPER}/ged/attach/${header?.image_id}`
    
    return (
        <div className="flex wrap w-full text-gray-600 relative print:!mt-2">
            <div className={"absolute w-[100px] h-[89px] justify-items-center"}>
                <img className={"w-auto !max-h-[85px]"} src={imagePath} alt="" />
            </div>

            <div className="flex flex-col justify-center items-center w-full h-[90px]">
                <p className="p-header text-xl font-bold text-center w-full">{header?.name ?? ""}</p>
                <p className="p-header text-xs text-center w-[70%]">{addressFormatted}</p>
                <p className="p-header text-xs font-bold text-center w-full uppercase mt-1">{ecapName}</p>
            </div>
        </div>
    );
};

export default EcapHeader;